const topics = [
  { name: '科幻巨制', count: '328部', hot: true },
  { name: '悬疑推理', count: '256部', hot: true },
  { name: '动作大片', count: '412部', hot: false },
  { name: '喜剧电影', count: '389部', hot: false },
  { name: '动画电影', count: '197部', hot: true },
  { name: '文艺剧情', count: '283部', hot: false },
  { name: '恐怖惊悚', count: '174部', hot: false },
  { name: '纪录纪实', count: '146部', hot: false },
  { name: '经典老片', count: '503部', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            按类型探索海量高清电影片库，找到最合您口味的影片
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((item, i) => (
            <div
              key={i}
              className={`group relative inline-flex items-center gap-2 px-5 py-3 rounded-full cursor-pointer transition-all duration-300 ${
                item.hot
                  ? 'bg-primary-50 text-primary-700 hover:bg-primary-100 border border-primary-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 border border-background-200/70'
              }`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{item.name}</span>
              <span className="text-xs opacity-60 whitespace-nowrap">{item.count}</span>
              {item.hot && (
                <span className="absolute -top-1.5 -right-1.5 w-5 h-5 flex items-center justify-center rounded-full bg-accent-500 text-white text-[10px] font-bold">
                  <i className="ri-fire-line"></i>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}